import React, { useEffect } from 'react';
import i18n from '../../i18n';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../store/rootReducer';
import { useIsMount } from '../../hooks/useIsMountHook';
import { checkIfMockServiceExistInWorkspaceThunk } from '../../store/mockServices/mockServiceActions';
import Button from 'react-bootstrap/Button';
import _ from 'lodash';
import BzmIcon from '../icons/BzmIcon';

type OpenWizardButtonProps = {
  onClick: () => void;
  /** Variant of the button to be used. If not specified
   * the color variant depends on existence of virtual service
   * within workspace. */
  variant?: 'primary' | 'secondary';

  size?: 'lg' | 'sm';
};

const OpenWizardButton = (props: OpenWizardButtonProps) => {
  const isMsInWorkspace = useSelector((state: ApplicationState) => state.mockservices.isMsInWorkspace);
  const dispatch = useDispatch();
  const isMount = useIsMount();

  useEffect(() => {
    if (isMount && _.isNil(props.variant)) {
      dispatch(checkIfMockServiceExistInWorkspaceThunk());
    }
  }, []);

  const getButtonVariant = () => {
    if (!_.isNil(props.variant)) {
      return props.variant;
    }
    return isMsInWorkspace ? 'secondary' : 'primary';
  };

  return (
    <Button
      className={'font-weight-semi-bold'}
      id={'qa-dd-panel-toggle'}
      variant={getButtonVariant()}
      onClick={props.onClick}
      size={props.size ? props.size : undefined}
    >
      <BzmIcon variant={'icon-bzm-setup-wizard'} className={'ml-1 mr-3'}></BzmIcon>
      {i18n.t('wizard:startNow')}
    </Button>
  );
};

export default OpenWizardButton;
